import { AxiosError } from "axios";

import { api } from "@/lib/axios";

export interface ConfirmSignUpBody {
	email: string;
	code: string;
}

export async function confirmSignUp({
	email,
	code,
}: ConfirmSignUpBody): Promise<
	| { status: "success"; data: { [key: string]: string } }
	| { status: "error"; errors: { [key: string]: string } }
> {
	try {
		const { data } = await api.post("/auth/check-code", {
			email,
			code,
		});

		return {
			status: "success",
			data: data.data.token,
		};
	} catch (error: unknown) {
		const axiosError = error as AxiosError<{
			errors: { [key: string]: string };
			message: string;
		}>;

		if (axiosError.response?.status === 401) {
			return {
				status: "error",
				errors: {
					code: axiosError.response.data.message,
				},
			};
		}

		if (axiosError.response?.status === 422) {
			return {
				status: "error",
				errors: axiosError.response.data.errors,
			};
		}

		return {
			status: "error",
			errors: {
				unknown: "Erro desconhecido. Tente novamente mais tarde.",
			},
		};
	}
}
